import * as types from './types';

export default {
  [types.SET_PERSON](state, person) {
    state.person = person;
  },
  [types.CACHE_PERSON](state, { key, person }) {
    state.cachedPerson[key] = person;
  },
  [types.SET_PERSON_BY_ID](state, person) {
    state.personById = person;
  },
  [types.SET_PERSON_BY_EMAIL](state, person) {
    state.personByEmail = person;
  },
  [types.CACHE_PERSON_BY_EMAIL](state, { key, person }) {
    state.cachedPersonByEmail[key] = person;
  },
  [types.SET_PERSONS](state, persons) {
    state.persons = persons;
  },
  [types.CACHE_PERSONS](state, { key, persons }) {
    state.cachedPersons[key] = persons;
  },
  [types.SET_RATING](state, rating) {
    state.person.rating = rating;
  },
};
